import React, { useEffect } from 'react';
import Button from '../../components/Button/Button';
import images from '../../assets';
import './Home.scss';
import Slider from '../../components/Slider/Slider';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import ProjectCard from '../../components/ProjectCard/ProjectCard';
import { useNavigate } from 'react-router-dom';

function Home() {
    const navigate = useNavigate();

    useEffect(() => {
        //scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const tnValues = [
        { name: 'Professional Service', icon: 'tn1' },
        { name: 'Superior Quality', icon: 'tn2' },
        { name: 'Skilled Team', icon: 'tn3' },
        { name: 'Timely Delivery', icon: 'tn4' },
        // { name: 'Experienced Crew', icon: 'tn5' },
    ];

    const tnServices = [
        {
            name: 'HVAC',
            img: 'hvacService',
            desc: 'Complete HVAC solutions including custom Air Handling Units, Heat Pumps, Heat Recovery Ventilators, and Cooling Towers for optimal climate control.',
        },
        {
            name: 'Building Automation',
            img: 'buildingAutomationServices',
            desc: 'Advanced digital control systems and remote monitoring solutions to optimize building performance and energy efficiency.',
        },
        {
            name: 'Plumbing',
            img: 'plumbingService',
            desc: 'Comprehensive plumbing services for underground and above-ground sanitary systems, including retrofits and modern installations.',
        },
        {
            name: 'Insulation',
            img: 'insulationService',
            desc: 'Professional installation and maintenance of plumbing pipe insulation to ensure energy efficiency and system protection.',
        },
    ];

    const projects = [
        {
            title: 'ST. LEO CATHOILC ELEMENTARY SCHOOL REPLACEMENT',
            location: 'Toronto, ON',
            scope: 'PLUMBING, HVAC, BAS',
            value: '$6,028,000',
            gc: 'Pre. Eng Contracting Ltd',
            status: 'Completed',
            completionDate: 'Oct 2024',
            type: 'Expansion and Renovation',
            img: 'stLeoCatholic',
        },
        {
            title: '60 PLAYFAIR AVENUE RENOVATIONS FOR REGINA MUNDI',
            location: 'Toronto, ON',
            scope: 'Mechanical (HVAC, Plumbing & Controls)',
            value: '$2,678,000',
            gc: 'Corebuild Construction Ltd',
            status: 'Completed',
            completionDate: 'July 2024',
            type: 'Expansion and Renovation',
            img: 'playfair',
        },
        {
            title: 'WINTER & VANIERS RESIDENCE YORK UNIVERSITY',
            location: 'Toronto, ON',
            scope: 'HVAC, Plumbing & Controls',
            value: '$1,400,000',
            gc: 'Brown Daniels Associates',
            status: 'Completed',
            completionDate: 'August 2016',
            type: 'Expansion and Renovation',
            img: 'winterAndWaniers',
        },
    ];

    return (
        <div>
            <section className="hero-section top-padding-mobile">
                <div className="hero-container">
                    <div className="hero-content">
                        <div className="hero-badge">
                            Premier Mechanical Contractors
                        </div>
                        <h1 className="hero-title">
                            Topnotch Mechanical Services Inc.
                        </h1>
                        <p className="hero-description">
                            Delivering exceptional mechanical solutions for
                            large-scale commercial and institutional projects.
                            We specialize in{' '}
                            <strong>
                                plumbing, HVAC, building automation, and
                                insulation
                            </strong>{' '}
                            services for school boards, municipalities, and
                            general contractors across the Greater Toronto Area.
                        </p>
                        <div className="hero-highlights">
                            <div className="hero-highlight-item">
                                <div className="highlight-icon">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <span>Licensed & Insured</span>
                            </div>
                            <div className="hero-highlight-item">
                                <div className="highlight-icon">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 2L2 7L12 12L22 7L12 2Z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M2 17L12 22L22 17"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M2 12L12 17L22 12"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <span>Commercial Expertise</span>
                            </div>
                            <div className="hero-highlight-item">
                                <div className="highlight-icon">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13 10V3L4 14H11V21L20 10H13Z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <span>Efficient Service</span>
                            </div>
                        </div>
                        <div className="hero-cta">
                            <Button
                                onClick={() => navigate('/services')}
                                margin={'0'}
                            >
                                Explore Our Services →
                            </Button>
                            <Button
                                onClick={() => navigate('/contact')}
                                margin={'0 0 0 16px'}
                                variant="dark"
                            >
                                Get a Quote
                            </Button>
                        </div>
                    </div>

                    <div className="hero-visual-section">
                        <div className="hero-img">
                            <Slider />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section topnotch-section">
                <div className="container">
                    <h3 className="title topnotch-title">
                        Why choose TOPNOTCH?
                    </h3>
                    <div className="section-content">
                        {tnValues?.map((item) => (
                            <div className="topnotch-item" key={item?.name}>
                                <img
                                    alt={item?.name}
                                    src={images[item?.icon]}
                                />
                                <span>{item?.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="section services-section">
                <div className="container">
                    <h3 className="title services-title">Services</h3>
                    <div className="section-content">
                        {tnServices?.map((item, index) => (
                            <ServiceCard key={index} item={item} />
                        ))}
                    </div>
                </div>
            </section>

            <section className="section projects-section">
                <div className="container">
                    <h3 className="title projects-title">Projects</h3>
                    <div className="section-content projects-wrap">
                        {/* <ProjectCard /> */}
                        {projects?.map((project, index) => (
                            <ProjectCard
                                key={index}
                                project={project}
                                index={index}
                            />
                        ))}
                    </div>
                    <Button
                        onClick={() => navigate('/projects')}
                        margin="48px auto"
                    >
                        View all Projects ➜
                    </Button>
                </div>
            </section>

            <section className="section safety-section">
                <div className="container">
                    <h3 className="title safety-title">
                        Health & Safety Policy
                    </h3>
                    <div className="safety-policies-grid">
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">01</span>
                                <h5>Commitment to Safety</h5>
                            </div>
                            <p>
                                Topnotch Mechanical Services is dedicated to
                                maintaining a safe and healthy environment for
                                employees, customers, and visitors. Safety is
                                integral to all our operations.
                            </p>
                        </div>
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">02</span>
                                <h5>Safe Workplace</h5>
                            </div>
                            <p>
                                We maintain clean, organized work areas and
                                ensure all tools and equipment are properly
                                maintained and used by trained personnel.
                                Potential hazards are regularly assessed and
                                mitigated.
                            </p>
                        </div>
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">03</span>
                                <h5>Employee Training</h5>
                            </div>
                            <p>
                                Staff receive ongoing training on workplace
                                safety, proper equipment use, and emergency
                                response. Employees are responsible for
                                following safety procedures and reporting any
                                unsafe conditions.
                            </p>
                        </div>
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">04</span>
                                <h5>Customer Safety</h5>
                            </div>
                            <p>
                                Access to repair areas is restricted. Clear
                                signage and designated waiting zones ensure
                                visitors remain safe while on-site.
                            </p>
                        </div>
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">05</span>
                                <h5>Environmental Safety</h5>
                            </div>
                            <p>
                                All chemicals, fluids, and waste materials are
                                safely handled, stored, and disposed of in line
                                with industry best practices to protect people
                                and the environment.
                            </p>
                        </div>
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">06</span>
                                <h5>Emergency Preparedness</h5>
                            </div>
                            <p>
                                Our facility is equipped with first-aid
                                supplies, fire safety equipment, spill-control
                                kits, and clearly marked emergency exits. Staff
                                are trained to respond promptly and safely to
                                any incident.
                            </p>
                        </div>
                        <div className="policy-point">
                            <div className="policy-point-header">
                                <span className="policy-number">07</span>
                                <h5>Continuous Improvement</h5>
                            </div>
                            <p>
                                Safety practices are regularly reviewed and
                                updated to ensure a secure environment and
                                continuous enhancement of workplace safety
                                standards.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Home;
